import { useEffect, useRef, useState } from "react";

import './style.css';
interface SearchableDropdownProps {
    options: string[];
    id?: string;
    selectedValue?: string | undefined | null;
    onSelect: (value: string) => void;
    onSearchTermChanged: (value: string) => void;
    getFriendlyNameForOptions: (option: string) => string;
    clearSearchTermAfterSelect?: boolean;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({ options, id, selectedValue, onSelect, onSearchTermChanged, getFriendlyNameForOptions, clearSearchTermAfterSelect }) => {
    const [query, setQuery] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [option, setOption] = useState(selectedValue);
    const inputRef = useRef(null);

    useEffect(() => {
        setQuery(selectedValue || '');
        setOption(selectedValue || '')
    }, [selectedValue])

    useEffect(() => {
        document.addEventListener("click", toggle);
        return () => document.removeEventListener("click", toggle);
    }, []);

    const selectOption = (option: string) => {
        setQuery(() => "");
        const firendlyOption = getFriendlyNameForOptions(option);
        onSelect(firendlyOption);
        setOption(firendlyOption);
        setIsOpen((isOpen) => !isOpen);
        if (clearSearchTermAfterSelect) {
            setQuery("");
            setOption("");
        }
    };

    function toggle(e: any) {
        setIsOpen(e && e.target === inputRef.current);
    }

    const filter = (options: string[]) => {
        return options.filter(
            (option) => getFriendlyNameForOptions(option).includes(query)
        );
    };

    const isNullOrEmpty = (value: string | null | undefined) => { return value === null || value === "" || value === undefined; }

    const getValueToDisplay = () => {
        if (!isNullOrEmpty(query)) return query ?? "";
        if (!isNullOrEmpty(option)) return option ?? "";

        return ""
    }

    const setNewSearchTerm = (newValue: string) => {
        setQuery(newValue);
        setOption(newValue);
        onSearchTermChanged(newValue);
    }

    return (
        <div className="dropdown">
            <div className="control">
                <div className="selected-value">
                    <input
                        className="form-control"
                        ref={inputRef}
                        type="text"
                        value={getValueToDisplay()}
                        name="searchTerm"
                        autoComplete="off"
                        onChange={(e) => setNewSearchTerm(e.target.value)}
                        onClick={toggle}
                    />
                </div>
            </div>

            <div className={`options ${isOpen ? "open" : ""}`}>
                {filter(options).map((option, index) => {
                    return (
                        <div
                            onClick={() => selectOption(option)}
                            className={`option ${option[1] === selectedValue ? "selected" : ""
                                }`}
                            key={`${id}-${index}`}
                        >
                            {getFriendlyNameForOptions(option)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchableDropdown;
